// React Hooks:
import React, { useState, useEffect } from "react";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
// Redux Toolkit Actions & State:
import { linkFileModalAction, linkFileModal } from "../linkFileModalSlice";
import { drawerShare } from "../../../main/home/drawer/drawer-item/drawer-share/drawerShareSlice";
// MUI Components:
import {
  Modal,
  Container,
  Box,
  Button,
  SvgIcon,
  Typography,
  useTheme,
  Skeleton,
} from "@mui/material";
// MUI Styles:,
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
// SVG Icones:
import { ReactComponent as CopyIcon } from "../../../../assets/icons/copy-icon.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/squareRemove-icon.svg";

const useStyles = makeStyles((theme) => ({
  backdropStyle: {
    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
      backdropFilter: "blur(2px)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  },
  modalContainer: {
    backgroundColor: "#FFFFFF",
    color: theme.palette.text.secondary,
    borderRadius: "8px",
    "&:focus": {
      outline: "none",
    },
  },
}));
const ResponsiveLinkFileModal = () => {
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const {
    linkFileModal: { openModal, link },
  } = useAppSelector(linkFileModal);
  const { shareFile } = useAppSelector(drawerShare);

  const [linkFile, setLinkFile] = useState("");

  useEffect(() => {
    setLinkFile(`${window.location.origin}/download/${link}`);
  }, [link]);

  return (
    <Modal
      open={openModal}
      onClose={() => dispatch(linkFileModalAction(false))}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1300,
        "&:focus": {
          outline: "none",
        },
        [theme.breakpoints.up("sm")]: {
          display: "none",
        },
      }}
      className={classes.backdropStyle}
    >
      <Container
        maxWidth={false}
        sx={{
          width: "80%",
          height: "240px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 12,
          p: { xs: 3 },
          "&:focus-visible": {
            outline: "none",
          },
        }}
        className={classes.modalContainer}
        id="ignoreDisableTouch"
      >
        <SvgIcon
          color="error"
          onClick={() => dispatch(linkFileModalAction(false))}
          component={CloseIcon}
          inheritViewBox
          sx={{
            width: "auto",
            height: "20px",
            cursor: "pointer",
            mr: "4px",
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
        />
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "26px",
              fontWeight: "bolder",
              color: theme.palette.secondary.main,
            }}
          >
            Link File
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "70px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: `2px solid ${theme.palette.secondary.main}`,
            p: "16px",
            backgroundColor: "#FBFAFE",
            borderRadius: "16px",
            textAlign: "center",
          }}
        >
          {shareFile.actionStatus === "loading" ? (
            <Skeleton
              variant="rounded"
              width={"90%"}
              height={"24px"}
              animation="wave"
              sx={{
                bgcolor: "#e8e8e8",
              }}
            />
          ) : (
            <Typography
              sx={{
                fontSize: "16px",
                color: theme.palette.info.main,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                height: "24px",
                textAlign: "left",
              }}
            >
              {linkFile}
            </Typography>
          )}
        </Box>

        <Box>
          <Button
            variant="contained"
            color="success"
            fullWidth
            type="submit"
            disabled={shareFile.actionStatus === "loading" ? true : false}
            sx={{
              width: "180px",
              height: "45px",
              fontSize: "18px",
              borderRadius: "8px",
              textTransform: "none",
              lineHeight: "0px",
              padding: "12px",
              ":disabled": {
                backgroundColor: "#C5C5C5",
                color: theme.palette.text.primary,
              },
            }}
            onClick={() => {
              if (!!linkFile) {
                navigator.clipboard.writeText(linkFile);
                enqueueSnackbar("Link file copied successfully to clipboard.", {
                  variant: "default",
                });
              }
            }}
          >
            <SvgIcon
              component={CopyIcon}
              inheritViewBox
              sx={{
                width: "auto",
                height: "20px",
                color: "inherit",
                cursor: "pointer",
                mr: "4px",
              }}
            />
            Copy Link
          </Button>
        </Box>
      </Container>
    </Modal>
  );
};

export default ResponsiveLinkFileModal;
